import { journalsServiceApi } from "@entities/api";

interface IUpdateSectionFourRecord {
  itemNoVersionId: string;
  updateSectionFourRequest: {
    mainJournalId: string;
    section4Id: string;
    section4ListId: string;
    itemPartOne: {
      isDefects: boolean;
      constructionControlInfo: string;
      controlEventPeriod: {
        beginDate: string;
        endDate: string;
      };
      defectsAbsenceRecord: string;
      defectFixingPlanDate?: string;
      defectDescriptionText?: string;
      updateDocs?: Array<any>;
      updateWorks?: Array<any>;
      createOtherDocs?: Array<any>;
      deleteOtherDocs?: Array<{ file: { id: string; fileId: string } }>;
      structuralElementName?: string;
      locationDescription?: string;
      locationType?: string;
      inspectionEmployeeId: string;
    };
  };
}

export async function updateSectionFourRecord({
  itemNoVersionId,
  updateSectionFourRequest,
}: IUpdateSectionFourRecord) {
  const formData = new FormData();

  const jsonBlob = new Blob([JSON.stringify(updateSectionFourRequest)], {
    type: "application/json",
  });

  formData.append("updateRequest", jsonBlob);

  updateSectionFourRequest.itemPartOne?.createOtherDocs?.forEach((doc: any) => {
    if (doc.file instanceof File || doc.file instanceof Blob) {
      formData.append("otherFiles", doc.file);
    }
  });

  const res = await journalsServiceApi.putForm(
    `/journals/section-four/items/${itemNoVersionId}/partOne`,
    formData,
  );

  return res.data;
}

